import { render } from "./VanillaE.vue?vue&type=template&id=64d3000a&scoped=true"
import script from "./VanillaE.vue?vue&type=script&lang=js"
export * from "./VanillaE.vue?vue&type=script&lang=js"

import "./VanillaE.vue?vue&type=style&index=0&id=64d3000a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d3000a"]])

export default __exports__